import { select, observe } from './animations/_util.js';
import { lines } from './animations/_lines.js';
import { words } from './animations/_words.js';
import { block } from './animations/_block.js';
import { kenBurns } from './animations/_ken-burns.js';
import { letters } from './animations/_letters.js';
import { image } from './animations/_image.js';
import { fade } from './animations/_fade.js';
import { scale } from './animations/_scale.js';
import { reveal } from './animations/_reveal.js';

/**
 * Auto animate a node based on it's data attributes
 *
 * @param {HTMLElement} node
 * @param {object} opts
 * @returns {HTMLElement}
 */
function animate( node, opts = {} ) {
	if ( !  node.dataset.animation ) {
		return;
	}

	if ( ! opts.delay && node.dataset.animationDelay ) {
		opts.delay = node.dataset.animationDelay;
	}

	if ( ! opts.duration && node.dataset.animationDuration ) {
		opts.duration = node.dataset.animationDuration;
	}

	if ( ! opts.threshold && node.dataset.animationThreshold ) {
		opts.threshold = node.dataset.animationThreshold;
	}

	switch ( node.dataset.animation ) {
		case 'ken-burns':
			kenBurns( node, opts );
		break;
		case 'lines':
			lines( node, opts );
		break;
		case 'letters':
			letters( node, opts );
		break;
		case 'words':
			words( node, opts );
		break;
		case 'image':
			image( node, opts );
		break;
		case 'block':
			block( node, opts );
		break;
		case 'fade':
			fade( node, opts );
		break;
		case 'scale':
			scale( node, opts );
		break;
		case 'reveal':
			reveal( node, opts );
		break;
	}


	return node;
}

export {
	animate,
	block,
	kenBurns,
	letters,
	lines,
	observe,
	select,
	words,
	image,
	scale,
	fade,
	reveal,
}
